import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, Checkbox } from 'react-bootstrap'

import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import { ScheduleAPI } from '../../../api/datamanager/ScheduleAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SearchBar } from '../../SearchBar';

export class LineDurationCalculationForm extends Component {
    static contextTypes = {
        edition: PropTypes.object,
        selectedProvider: PropTypes.string,
    }
    constructor(props){
        super(props);

        this.state = {
            lines: [],
            filteredLines: [],
            selectedLineCodes: [],
            linesWithoutConfigurations: [],
            linesWithConfigurations: [],
            selectedScheduleIds: [],
            schedules: [],
            schedulesPerLine: {},
            schedulesLoading: false,

            title: "",

            showLinesModal: false,
            showConfigurationModal: false,

            noSelectionErrorShow: false,
            noMinimumTimeErrorShow: false,

            form: {
                overrideSettings: false,
                minimumMinutes: 1,
                startHour: "08:00",
                endHour: "15:00",
                useMapPoints: false
            }
        };
    }

    componentDidMount() {
        const { show, formTitle, lines } = this.props;
        this.setState({
            lines: lines,
            filteredLines: lines,
            showLinesModal: show,
            title: formTitle
        });
    }

    onConfirm(){
        const { selectedLineCodes, lines, showLinesModal, form, linesWithoutConfigurations, linesWithConfigurations} = this.state;

        if(showLinesModal) {
            let selectedLines = lines.filter(line => selectedLineCodes.includes(line.code));

            let linesWithoutConfigurations = selectedLines
                .filter(line => undefined === line.duration);

            let linesWithConfigurations = selectedLines
                .filter(line => undefined !== line.duration);

            if (linesWithoutConfigurations.length > 0 || linesWithConfigurations.length > 0) {
                const { edition } = this.context;
                const { isDraft } = this.props;

                const planningEdition = isDraft ? edition.draftPlanning : edition.planning;
                const networkEdition = isDraft ? edition.draftNetwork : edition.network;

                this.setState({ schedulesLoading: true });
                Promise.all(
                    selectedLines.map(line => ScheduleAPI.loadByLine(planningEdition, networkEdition, line.id))
                ).then(results => {
                    const schedulesPerLine = {};
                    const allSchedules = results.flatMap((r, i) => {
                        const parsed = JSON.parse(r);
                        schedulesPerLine[selectedLines[i].code] = parsed;
                        return parsed;
                    });
                    const uniqueSchedules = allSchedules.filter((s, i, arr) => arr.findIndex(x => x.id === s.id) === i);
                    this.setState({ schedules: uniqueSchedules, schedulesPerLine, schedulesLoading: false });
                }).catch(() => {
                    this.setState({ schedulesLoading: false });
                });

                this.setState({
                    showLinesModal: false,
                    showConfigurationModal: true,
                    linesWithoutConfigurations: linesWithoutConfigurations,
                    linesWithConfigurations: linesWithConfigurations,
                })
            }
            else {
                this.setState({ noSelectionErrorShow: selectedLineCodes.length === 0 });
            }
        }
        else {
            const showConfigSection = form.overrideSettings || linesWithoutConfigurations.length > 0;
            const noMinimumTimeErrorShow = showConfigSection && !form.useMapPoints && (!form.minimumMinutes || Number(form.minimumMinutes) === 0);

            if (noMinimumTimeErrorShow) {
                this.setState({ noMinimumTimeErrorShow: true });
                return;
            }

            this.setState({ noMinimumTimeErrorShow: false });

            const [startHour, startMinutes] = form.startHour.split(':').map(Number);
            const [endHour, endMinutes] = form.endHour.split(':').map(Number);

            const startValue = startHour * 60 + startMinutes;
            const endValue = endHour * 60 + endMinutes;

            const { selectedScheduleIds, schedulesPerLine } = this.state;
            const allLineCodes = [...linesWithConfigurations.map(l => l.code), ...linesWithoutConfigurations.map(l => l.code)];
            const scheduleIdsPerLineCode = {};
            allLineCodes.forEach(lineCode => {
                const lineScheduleIds = (schedulesPerLine[lineCode] || []).map(s => s.id);
                scheduleIdsPerLineCode[lineCode] = selectedScheduleIds.filter(id => lineScheduleIds.includes(id));
            });

            const data = {
                lineCodesWithConfiguration: linesWithConfigurations.map(line => line.code),
                lineCodesWithoutConfiguration: linesWithoutConfigurations.map(line => line.code),
                overrideSettings: form.overrideSettings,
                minimumMinutes: Number(form.minimumMinutes),
                startHour: startValue,
                endHour: endValue,
                useMapPoints: form.useMapPoints,
                selectedScheduleIds,
                scheduleIdsPerLineCode,
            };

            this.props.onSave(data);
        }
    }

    onCancel() {
        const { showLinesModal } = this.state;
        if (showLinesModal) {
            this.props.onHide();
        }
        else {
            this.setState({
                form: {
                    overrideSettings: false,
                    minimumMinutes: 1,
                    startHour: "08:00",
                    endHour: "15:00",
                    useMapPoints: false
                },
                selectedScheduleIds: [],
                schedules: [],
                schedulesPerLine: {},
                schedulesLoading: false,
                showLinesModal: true,
                showConfigurationModal: false,
                linesWithoutConfigurations: [],
                linesWithConfigurations: [],
                noMinimumTimeErrorShow: false,
            });
        }
    }

    onToggleScheduleId(scheduleId) {
        const { selectedScheduleIds } = this.state;
        const newIds = selectedScheduleIds.includes(scheduleId)
            ? selectedScheduleIds.filter(id => id !== scheduleId)
            : [...selectedScheduleIds, scheduleId];
        this.setState({ selectedScheduleIds: newIds });
    }

    onSelectLine = (e, code) => {
        const { selectedLineCodes } = this.state;
        const isChecked = e.target.checked;

        const newSelection = isChecked
            ? [...selectedLineCodes, code]
            : selectedLineCodes.filter((lineCode) => lineCode !== code);

        this.setState({ selectedLineCodes: newSelection });
    };

    onSelectAllLines() {
        const { selectedLineCodes, filteredLines } = this.state;

        const filteredCodes = filteredLines.map(line => line.code);

        const allFilteredSelected = filteredCodes.length > 0 && filteredCodes.every(code => selectedLineCodes.includes(code));

        if (allFilteredSelected) {
            const newSelection = selectedLineCodes.filter(code => !filteredCodes.includes(code));
            this.setState({ selectedLineCodes: newSelection });
        } else {
            const newSelection = Array.from(new Set([...selectedLineCodes, ...filteredCodes]));
            this.setState({ selectedLineCodes: newSelection });
        }
    }

    onChangeValue(e, value) {
        const { form } = this.state;

        const inputValue = (e && e.target) ? e.target.value : e;

        if("endHour" === value || "startHour" === value) {
            if (inputValue && inputValue.match(/^\d{2}:\d{2}$/)) {
                form[value] = inputValue;
            }
        }
        else {
            form[value] = inputValue;
        }

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value) {
        const { form } = this.state;

        form[value] = e.target.checked;

        if (value === "useMapPoints") {
            if (e.target.checked && Number(form.minimumMinutes) === 1) {
                form.minimumMinutes = 0;
            } else if (!e.target.checked && Number(form.minimumMinutes) === 0) {
                form.minimumMinutes = 1;
            }
        }

        this.setState({
            form: form,
        });
    }

    onSearch = (filter) => {
        const { lines } = this.state;

        if (!filter || filter.trim() === "") {
            this.setState({ filteredLines: lines });
            return;
        }
        const q = filter.toLowerCase();
        const filtered = (lines || []).filter(l => {
            const code = (l.code || "").toLowerCase();
            const name = (l.goName || "").toLowerCase();
            return code.includes(q) || name.includes(q);
        });
        this.setState({ filteredLines: filtered });
    }

    renderError(show, message) {
        return show ? <div style={{ color: 'red', marginLeft: '5px' }}>{message}</div> : null;
    }

    renderConfigurationModal() {
        const { showConfigurationModal, linesWithConfigurations, linesWithoutConfigurations, form, selectedScheduleIds, schedules, schedulesLoading } = this.state;

        if (!showConfigurationModal) {
            return null;
        }

        return (
            <div>
                {linesWithoutConfigurations.length > 0 ? (
                    <div className="line-selection-container scrollable-container" style={{ marginBottom: '15px', color: '#d9534f', padding: '10px', border: '1px solid #d9534f', borderRadius: '5px', backgroundColor: '#f2dede' }}>
                        <strong style={{ fontSize: '1.1rem' }}>Atenção:</strong> As seguintes linhas não possuem configurações associadas:
                        <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                            {linesWithoutConfigurations.map((line) => (
                                <li key={line.id} style={{ marginBottom: '5px' }}>
                                    <span className="line-code" style={{ fontWeight: 'bold' }}>{line.code}</span> - <span className="line-name">{line.goName}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <div style={{ marginBottom: '15px', color: '#5cb85c', padding: '10px', border: '1px solid #5cb85c', borderRadius: '5px', backgroundColor: '#dff0d8' }}>
                        <strong style={{ fontSize: '1.1rem' }}>Informação:</strong> Todas as linhas possuem configurações associadas.
                    </div>
                )}
                <div className="line-selection-container scrollable-container" style={{ marginBottom: '15px' }}>
                    {linesWithConfigurations.map((line) => {
                        const startHour = Math.floor(line.duration.startHour / 60).toString().padStart(2, '0');
                        const startMinutes = (line.duration.startHour % 60).toString().padStart(2, '0');
                        const endHour = Math.floor(line.duration.endHour / 60).toString().padStart(2, '0');
                        const endMinutes = (line.duration.endHour % 60).toString().padStart(2, '0');

                        const startValue = `${startHour}:${startMinutes}`;
                        const endValue = `${endHour}:${endMinutes}`;

                        return (
                            <div key={line.id} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                                <span className="line-code" style={{ fontWeight: 'bold' }}>{line.code}</span> - <span className="line-name">{line.goName}</span>
                                <br />
                                <span style={{ fontSize: '0.9rem', color: '#555' }}>Tempo mínimo: {line.minimumMinutes} minutos entre {startValue} e {endValue}</span>
                            </div>
                        );
                    })}
                </div>
                <div>
                    <Form>
                        <FormGroup controlId="formOverrideSettings" style={{ marginBottom: '15px' }}>
                            <Checkbox
                                className="form-checkbox"
                                checked={form.overrideSettings}
                                onChange={(e) => this.onCheckValue(e, "overrideSettings")}>
                                <strong>Sobrepor configurações existentes</strong>
                            </Checkbox>
                        </FormGroup>
                        {(form.overrideSettings || linesWithoutConfigurations.length > 0) && (
                            <div>
                                <FormGroup controlId="formMinTime" style={{ marginBottom: '15px' }}>
                                    <ControlLabel>Tempo Mínimo de Minutos Entre Duas Paragens</ControlLabel>
                                    <FormControl
                                        type="number"
                                        min={form.useMapPoints ? "0" : "1"}
                                        value={form.minimumMinutes}
                                        placeholder="Introduza o tempo mínimo em minutos"
                                        onChange={(e) => this.onChangeValue(e, 'minimumMinutes')}
                                    />
                                </FormGroup>
                                <FormGroup controlId="formUseMapPoints" style={{ marginBottom: '15px' }}>
                                    <Checkbox
                                        className="form-checkbox"
                                        checked={form.useMapPoints}
                                        onChange={(e) => this.onCheckValue(e, "useMapPoints")}>
                                        <strong>Utilizar Pontos Notáveis como Limite</strong>
                                    </Checkbox>
                                </FormGroup>
                                <FormGroup controlId="formSchedules" style={{ marginBottom: '15px' }}>
                                    <ControlLabel>Horários a Utilizar no Cálculo</ControlLabel>
                                    {schedulesLoading
                                        ? <LoadingSpinner />
                                        : <div className="line-selection-container scrollable-container">
                                            {schedules.map(schedule => (
                                                <div key={schedule.id}>
                                                    <Checkbox
                                                        className="form-checkbox"
                                                        checked={selectedScheduleIds.includes(schedule.id)}
                                                        onChange={() => this.onToggleScheduleId(schedule.id)}>
                                                        {schedule.name}
                                                    </Checkbox>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </FormGroup>
                                <FormGroup controlId="formStartHour" className="mb-4">
                                    <ControlLabel>Hora de Início</ControlLabel>
                                    <div>
                                        <TimePicker
                                            onChange={(e) => this.onChangeValue(e, 'startHour')}
                                            value={form.startHour || '08:00'}
                                            locale="pt-pt"
                                            format="HH:mm"
                                        />
                                    </div>
                                </FormGroup>
                                <FormGroup controlId="formEndHour" style={{ marginBottom: '15px' }}>
                                    <ControlLabel>Hora de Fim</ControlLabel>
                                    <div>
                                        <TimePicker
                                            onChange={(e) => this.onChangeValue(e, 'endHour')}
                                            value={form.endHour || '15:00'}
                                            locale="pt-pt"
                                            format="HH:mm"
                                        />
                                    </div>
                                </FormGroup>
                            </div>
                        )}
                    </Form>
                </div>
            </div>
        );
    }

    renderLineModal() {
        const { selectedLineCodes, showLinesModal, filteredLines } = this.state;

        if (undefined === filteredLines || !showLinesModal) {
            return null;
        }

        const allFilteredSelected = filteredLines.length > 0 && filteredLines.every(l => selectedLineCodes.includes(l.code));

        return (
            <Form>
                <FormGroup controlId="formLines">
                    <ControlLabel className="mb-3 font-weight-bold">
                        Selecione as linhas para calcular as durações:
                        <span
                            className="message-form-span" style={{ fontSize: '1.2rem', marginLeft: '5px' }}
                            onClick={() => this.onSelectAllLines()}>
                            {allFilteredSelected ? "Deselecionar tudo" : "Selecionar tudo"}
                        </span>
                    </ControlLabel>
                    <div className="search-bar" style={{ marginBottom: '10px' }}>
                        <SearchBar onSearch={(a) => this.onSearch(a)} />
                    </div>
                    <div className="line-selection-container scrollable-container">
                        {filteredLines.map((line) => (
                            <div key={line.id}>
                                <Checkbox
                                    className="form-checkbox"
                                    checked={selectedLineCodes.includes(line.code)}
                                    onChange={(e) => this.onSelectLine(e, line.code)}
                                >
                                    <span className="line-code">{line.code}</span> - <span className="line-name">{line.goName}</span>
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                </FormGroup>
            </Form>
        );
    }

    render() {
        const { title, lines } = this.state;
        const { show } = this.props;

        if(undefined === lines) {
            return null;
        }

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderLineModal()}
                    {this.renderConfigurationModal()}
                    <ButtonToolbar>
                        {this.renderError(this.state.noSelectionErrorShow, 'É necessário definir uma linha')}
                        {this.renderError(this.state.noMinimumTimeErrorShow, 'É necessário definir um tempo mínimo')}
                        <Button onClick={() => this.onConfirm()}> CONFIRMAR </Button>
                        <Button onClick={() => this.onCancel()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
